var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronDown = function SvgChevronDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2928 7.43299C5.4801 7.2548 5.7341 7.1547 5.99895 7.1547L13.9929 7.14286C14.1255 7.14176 14.257 7.16581 14.3798 7.2136C14.5025 7.26139 14.614 7.33197 14.7078 7.42121C14.8016 7.51045 14.8758 7.61657 14.926 7.73338C14.9762 7.85019 15.0015 7.97535 15.0003 8.10155C14.9992 8.22775 14.9716 8.35247 14.9193 8.46843C14.8669 8.58439 14.7908 8.68927 14.6954 8.77695L10.7003 12.5788C10.513 12.757 10.259 12.8571 9.99412 12.8571C9.72928 12.8571 9.47528 12.757 9.28798 12.5788L5.2928 8.77695C5.10555 8.59871 5.00037 8.357 5.00037 8.10497C5.00037 7.85294 5.10555 7.61123 5.2928 7.43299Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ChevronDown.13493fca1b2d8303708e82950d05d4db.svg";